export enum MaritalStatusEnum {
  Married = 'married',
  Other = 'other',
  Single = 'single',
}
